import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import "./Coaching.css";

export default function Coaching() {
  return (
    <motion.section
      className="coaching-page"
      initial={{ opacity: 0, y: 40 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.8 }}
    >
      {/* Hero Section */}
      <div className="coaching-hero">
        <div className="overlay">
          <h1>Badminton Coaching at SmashKaro</h1>
          <p>
            Whether you’re just getting started or pushing for your next
            tournament, SmashKaro has the perfect coaching option for you.
          </p>
        </div>
      </div>

      {/* Coaching Tabs Section */}
      <div className="coaching-tabs">
        <Link to="/coaching/private" className="tab-card private">
          <h2>Private Coaching</h2>
          <p>1-on-1 focused sessions tailored to your goals and level.</p>
        </Link>

        <Link to="/coaching/group" className="tab-card group">
          <h2>Group Sessions</h2>
          <p>Train in small, fun, and energetic groups with guided drills.</p>
        </Link>
      </div>
    </motion.section>
  );
}
